export function validateFee(fee) {
  let value;

  if (fee.includes('.')) {
    value = parseFloat(fee);
  } else {
    value = parseInt(fee, 10);
  }

  if (value > 100) {
    value = 100;
  }

  if (value < 0) {
    value = 0;
  }

  return value;
}
